export default __webpack_public_path__ + "static/media/Sanjam_Gupta_AHV_In_Moms_We_Trust.46df6a71.jpg";